export default {
  CONFIG_USER_INFO_RECEIVED: 'CONFIG_USER_INFO_RECEIVED',
  CONFIG_UPDATE_CTX_FETCH: 'CONFIG_UPDATE_CTX_FETCH',
  CONFIG_UPDATE_CTX_SUCCESS: 'CONFIG_UPDATE_CTX_SUCCESS',
  CONFIG_UPDATE_CTX_ERROR: 'CONFIG_UPDATE_CTX_ERROR',
};
